import { Link } from 'react-router-dom';
import URLS from 'URLS';

import Button from '@mui/material/Button';
import { PersonIconAvatar } from 'components/display/Avatars';

type PersonIconProps = {
  name?: string;
  img?: string;
};

const PersonIcon = ({ name = '', img }: PersonIconProps) => {
  return (
    <Button component={Link} onClick={URLS.ACCOUNT === window.location.pathname ? () => window.location.reload() : undefined} to={URLS.ACCOUNT}>
      <PersonIconAvatar src={img}>{name.substring(0, 1)}</PersonIconAvatar>
    </Button>
  );
};

export default PersonIcon;
